import * as React from "react";
import cn from "clsx";

export type CardProps = {
  role?: "hero" | "sidekick";
  variant?: "primary" | "secondary" | "tertiary";
} & React.HTMLAttributes<HTMLDivElement>;

const Card = React.forwardRef<HTMLDivElement, CardProps>(
  (
    {
      className,
      role = "hero",
      variant = "primary",
      children,
      style,
      ...props
    },
    ref
  ) => {
    return (
      <div
        className={cn(
          "in-card",
          `in-card--${role}`,
          `in-card--${variant}`,
          className
        )}
        ref={ref}
        {...props}
        style={{ ...style }}
      >
        {children}
      </div>
    );
  }
);

Card.displayName = "Card";

export { Card };
